import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

const getConfig = () => {
    const token = store.getState().auth.token;

    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };

    return config;
};

export const createEmployeeAuth = (formValues) => async (dispatch) => {
    try {
        const response = await backend.post(
            "api/contact/employee-auth/",
            { ...formValues },
            getConfig()
        );
        if (response.status === 201) {
            dispatch({
                type: types.CREATE_EMPLOYEE_AUTH,
                payload: { ...response.data },
            });
            message.success("Employee PIN created successfully");
            return response.data;
        }
    } catch (error) {
        message.error("Failed to create employee PIN");
        console.log(error);
    }
};

export const getAllEmployeeAuth = () => async (dispatch) => {
    try {
        const response = await backend.get("api/contact/employee-auth/", getConfig());
        if (response.status === 200) {
            dispatch({
                type: types.GET_ALL_EMPLOYEE_AUTH,
                payload: response.data,
            });
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
};

export const deleteEmployeeAuth = (id) => async (dispatch) => {
    try {
        const response = await backend.delete(
            `api/contact/employee-auth/${id}/`,
            getConfig()
        );
        if (response.status === 204) {
            dispatch({ type: types.DELETE_EMPLOYEE_AUTH, payload: id });
            message.success("Employee PIN deleted successfully");
        }
    } catch (error) {
        message.error("Failed to delete employee PIN");
        console.log(error);
    }
};

export const updateEmployeeAuth = (id, formValues) => async (dispatch) => {
    try {
        const response = await backend.patch(
            `api/contact/employee-auth/${id}/`,
            formValues,
            getConfig()
        );
        if (response.status === 200) {
            message.success("Updated Successfully");
            dispatch({
                type: types.UPDATE_EMPLOYEE_AUTH,
                payload: { ...response.data },
            });
            return response.data;
        }
    } catch (error) {
        message.error("Failed to update employee PIN");
        console.log(error);
    }
};
